import { ReactNode } from 'react';
import { Colors } from '@mercator-gcp/grout';
import ClearAllButton from 'components/elements/ClearAllButton';
import { FlexRow } from 'components/layout/FlexRow';

/**
 * Sticky footer bar for a filter sidebar. A top divider line separates it from
 * the scrolling filter list above. `SidebarClearAllFooter` is the common case:
 * a single "Clear all" action that resets the sidebar's filters to their
 * defaults. Shared across every filter sidebar.
 */

const footerStyle = {
  borderTop: `1px solid ${Colors.ArmyGreen300}`,
  width: '100%',
  paddingY: 'padding_12',
  paddingX: 'padding_8',
  display: 'flex',
  background: 'brand.white',
};

type SidebarFooterProps = {
  children: ReactNode;
};

export const SidebarFooter = ({ children }: SidebarFooterProps) => {
  return <FlexRow sx={footerStyle}>{children}</FlexRow>;
};

type SidebarClearAllFooterProps = {
  onClick: () => void;
};

export const SidebarClearAllFooter = ({ onClick }: SidebarClearAllFooterProps) => {
  return (
    <SidebarFooter>
      <ClearAllButton onClick={onClick} />
    </SidebarFooter>
  );
};

export default SidebarClearAllFooter;
